/**
 * @fileoverview added by tsickle
 * Generated from: models/worker.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/** @enum {string} */
var WorkerTrustLevel = {
    Trialling: "trialling",
    Trusted: "trusted",
};
export { WorkerTrustLevel };
/** @enum {string} */
var WorkerStatus = {
    Active: "active",
    Forgotten: "forgotten",
    Inactive: "inactive",
    NoNewAccounts: "nonewaccounts",
    Onboarding: "onboarding",
    Pending: "pending",
};
export { WorkerStatus };
/** @enum {string} */
var InactivityReason = {
    KeepExistingCustomers: "appkeep",
    WantsToLeave: "appleave",
    Other: "prslapp",
};
export { InactivityReason };
/**
 * @record
 */
export function AreasByStrength() { }
if (false) {
    /** @type {?} */
    AreasByStrength.prototype.oneOff;
    /** @type {?} */
    AreasByStrength.prototype.regular;
}
/** @type {?} */
export var areasByStrength = model.extend({
    modelName: 'areas'
});
/**
 * @record
 */
export function BaseCustomerWorker() { }
if (false) {
    /** @type {?} */
    BaseCustomerWorker.prototype.currentRating;
    /** @type {?} */
    BaseCustomerWorker.prototype.firstNames;
    /** @type {?} */
    BaseCustomerWorker.prototype.gender;
    /** @type {?} */
    BaseCustomerWorker.prototype.image;
    /** @type {?} */
    BaseCustomerWorker.prototype.primaryTelephoneNumber;
    /** @type {?} */
    BaseCustomerWorker.prototype.worksWithCats;
    /** @type {?} */
    BaseCustomerWorker.prototype.worksWithDogs;
    /** @type {?} */
    BaseCustomerWorker.prototype.worksWithOtherPets;
}
/**
 * @record
 */
function BaseWorker() { }
if (false) {
    /** @type {?} */
    BaseWorker.prototype.accountNumber;
    /** @type {?} */
    BaseWorker.prototype.adminFee;
    /** @type {?} */
    BaseWorker.prototype.applicantId;
    /** @type {?|undefined} */
    BaseWorker.prototype.assignedAreas;
    /** @type {?} */
    BaseWorker.prototype.basePay;
    /** @type {?} */
    BaseWorker.prototype.canUpdateOwnStatus;
    /** @type {?} */
    BaseWorker.prototype.city;
    /** @type {?} */
    BaseWorker.prototype.classification;
    /** @type {?} */
    BaseWorker.prototype.currentAppVersion;
    /** @type {?} */
    BaseWorker.prototype.email;
    /** @type {?} */
    BaseWorker.prototype.emergencyContactName;
    /** @type {?} */
    BaseWorker.prototype.emergencyContactNumber;
    /** @type {?} */
    BaseWorker.prototype.emergencyContactRelation;
    /** @type {?} */
    BaseWorker.prototype.hourlyBonus;
    /** @type {?} */
    BaseWorker.prototype.id;
    /** @type {?} */
    BaseWorker.prototype.internalId;
    /** @type {?} */
    BaseWorker.prototype.isEligibleForBonus;
    /** @type {?} */
    BaseWorker.prototype.lastName;
    /** @type {?} */
    BaseWorker.prototype.line1;
    /** @type {?} */
    BaseWorker.prototype.line2;
    /** @type {?} */
    BaseWorker.prototype.line3;
    /** @type {?} */
    BaseWorker.prototype.nameOnAccount;
    /** @type {?|undefined} */
    BaseWorker.prototype.nationalInsuranceNumber;
    /** @type {?} */
    BaseWorker.prototype.noNewAccountsDate;
    /** @type {?} */
    BaseWorker.prototype.numRatings;
    /** @type {?|undefined} */
    BaseWorker.prototype.payIncreaseDate;
    /** @type {?} */
    BaseWorker.prototype.pendingRemoval;
    /** @type {?} */
    BaseWorker.prototype.reasonForInactivity;
    /** @type {?} */
    BaseWorker.prototype.reasonForInactivityDescription;
    /** @type {?} */
    BaseWorker.prototype.reasonForInactivityDisplay;
    /** @type {?} */
    BaseWorker.prototype.sortCode;
    /** @type {?|undefined} */
    BaseWorker.prototype.startedWork;
    /** @type {?} */
    BaseWorker.prototype.status;
    /** @type {?} */
    BaseWorker.prototype.telephoneNumbersForApi;
    /** @type {?} */
    BaseWorker.prototype.travelPreferences;
    /** @type {?} */
    BaseWorker.prototype.trustLevel;
    /** @type {?} */
    BaseWorker.prototype.urlOps;
}
/**
 * @record
 */
function WorkerExpandables() { }
if (false) {
    /** @type {?|undefined} */
    WorkerExpandables.prototype.allTimeMetrics;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.applicant;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.backgroundCheck;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.housekeepDevice;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.isEligibleForExtraJobs;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.isRejoiner;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.last60DaysMetrics;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.last90DaysMetrics;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.lastActivationDt;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.lastAppUsage;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.lastConfirmationDt;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.lastMoodSample;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.lastVisitDate;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.metricsClassification;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.postcode;
    /** @type {?|undefined} */
    WorkerExpandables.prototype.sinceActivationMetrics;
}
/**
 * @record
 */
function WorkerModelMixin() { }
if (false) {
    /** @type {?|undefined} */
    WorkerModelMixin.prototype.keysToCollect;
    /** @type {?|undefined} */
    WorkerModelMixin.prototype.keysToGive;
    /** @type {?} */
    WorkerModelMixin.prototype.fullName;
    /** @type {?} */
    WorkerModelMixin.prototype.getHourlyRate;
    /** @type {?} */
    WorkerModelMixin.prototype.isInactive;
    /** @type {?} */
    WorkerModelMixin.prototype.isNna;
    /** @type {?} */
    WorkerModelMixin.prototype.isOnboarding;
    /** @type {?} */
    WorkerModelMixin.prototype.isPending;
    /** @type {?} */
    WorkerModelMixin.prototype.isPendingRemoval;
    /** @type {?} */
    WorkerModelMixin.prototype.isTrialling;
    /** @type {?} */
    WorkerModelMixin.prototype.noRatings;
}
/**
 * @record
 */
export function Worker() { }
/** @type {?} */
export var worker = model.extend({
    modelName: 'worker',
    getHourlyRate: /**
     * @return {?}
     */
    function () {
        return this.isEligibleForBonus ? this.basePay + this.hourlyBonus : this.basePay;
    },
    isInactive: /**
     * @return {?}
     */
    function () {
        return this.status === WorkerStatus.Inactive;
    },
    isNna: /**
     * @return {?}
     */
    function () {
        return this.status === WorkerStatus.NoNewAccounts;
    },
    isOnboarding: /**
     * @return {?}
     */
    function () {
        return this.status === WorkerStatus.Onboarding;
    },
    isPending: /**
     * @return {?}
     */
    function () {
        return this.status === WorkerStatus.Pending;
    },
    isTrialling: /**
     * @return {?}
     */
    function () {
        return this.trustLevel === WorkerTrustLevel.Trialling;
    },
    noRatings: /**
     * @return {?}
     */
    function () {
        return this.currentRating === null;
    }
});
defineModelProperties(worker, {
    fullName: {
        get: /**
         * @return {?}
         */
        function () {
            return this.firstNames + " " + this.lastName;
        }
    }
});
